// import * as React from 'react'
/**
 * 组件默认属性，所有组件的默认属性都在这里写，
 * 而不是在组件文件中以“componentName.defaultProps”的方式去写
 * componentName: defaultPropsObj
 * （用于处理用户自定义默认属性）
 */
var compDefaultProps = {};
export default compDefaultProps;